import React from 'react';
import PropTypes from 'prop-types';
import format from 'string-template';

import { Title, SubTitle } from '../../../../components/v2/Card';
import { StyledCard } from './styles';

import texts from './texts';

const getDedicatedAcDescription = (isSingleAc, isCoachPoolEligible) => {
  if (isCoachPoolEligible) {
    return isSingleAc ? texts.dedicatedAcDescription : texts.dedicatedAcsDescription;
  }
  return isSingleAc ? texts.dedicatedAcIneligibleDescription : texts.dedicatedAcsIneligibleDescription;
};

/*
  A pooled coach reads the same whether or not they can be pooled: a coach without Assistant Coaching who still
  has a POOL row is in the pool until it is closed.
*/
const getCardLabels = (coachName, isCoachPooled, currentAcNames, isCoachPoolEligible) => {
  if (isCoachPooled) {
    return {
      title: format(texts.pooledTitle, { coach: coachName }),
      description: texts.pooledDescription,
    };
  }

  if (currentAcNames.length) {
    const isSingleAc = currentAcNames.length === 1;

    return {
      title: format(isSingleAc ? texts.dedicatedAcTitle : texts.dedicatedAcsTitle, {
        coach: coachName,
        count: currentAcNames.length,
      }),
      description: format(getDedicatedAcDescription(isSingleAc, isCoachPoolEligible), {
        acNames: currentAcNames.join(', '),
        count: currentAcNames.length,
      }),
    };
  }

  return {
    title: format(texts.unassignedTitle, { coach: coachName }),
    description: isCoachPoolEligible ? texts.unassignedDescription : texts.unassignedIneligibleDescription,
  };
};

const PoolAssignmentCard = ({
  coachName, isCoachPooled, currentAcNames, isCoachPoolEligible,
}) => {
  const { title, description } = getCardLabels(coachName, isCoachPooled, currentAcNames, isCoachPoolEligible);

  return (
    <StyledCard>
      <Title>{title}</Title>
      <SubTitle>{description}</SubTitle>
    </StyledCard>
  );
};

PoolAssignmentCard.propTypes = {
  coachName: PropTypes.string.isRequired,
  isCoachPooled: PropTypes.bool.isRequired,
  currentAcNames: PropTypes.array.isRequired,
  isCoachPoolEligible: PropTypes.bool.isRequired,
};

export default PoolAssignmentCard;
